export const CLEAR_STORE = 'palliative-care/clearStore';
export const clearStore = () => ({ type: CLEAR_STORE });



// WEBPACK FOOTER //
// ./src/store/actions.js